var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestModule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.678,
    height: 24.677,
    viewBox: "0 0 24.678 24.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1664",
    "data-name": "Group 1664",
    transform: "translate(17023 2167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1660",
    "data-name": "Group 1660",
    transform: "translate(-17023 -2167)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 12.339,
    cy: 12.339,
    r: 12.339,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163_1_",
    "data-name": "Group 163 (1)",
    transform: "translate(-17017 -2161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4072",
    "data-name": "Path 4072",
    d: "M12.739,69.45h-.555v-.776a.331.331,0,0,0-.331-.331.335.335,0,0,0-.335.331v.776H1.552V63.356a.547.547,0,0,1,.551-.539H5.649a.335.335,0,0,0,.331-.335.331.331,0,0,0-.331-.331H2.1A1.225,1.225,0,0,0,.878,63.376V69.45H.331A.331.331,0,0,0,0,69.781v2.451a1.225,1.225,0,0,0,.355.862,1.225,1.225,0,0,0,.87.343H11.845a1.227,1.227,0,0,0,1.225-1.225V69.76a.331.331,0,0,0-.331-.31ZM12.4,72.211a.543.543,0,0,1-.56.56H1.225a.543.543,0,0,1-.56-.56v-2.1H12.4Z",
    transform: "translate(0 -60.366)",
    fill: "#4776da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4073",
    "data-name": "Path 4073",
    d: "M172.662,369.778h-2.655a.333.333,0,1,0,0,.666h2.655a.333.333,0,1,0,0-.666Z",
    transform: "translate(-164.799 -359.159)",
    fill: "#4776da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4074",
    "data-name": "Path 4074",
    d: "M222.177,0H218.64a1.225,1.225,0,0,0-1.225,1.225V3.517a.331.331,0,1,0,.662,0V1.225a.555.555,0,0,1,.555-.551h3.545a.555.555,0,0,1,.56.551V5.649a.556.556,0,0,1-.56.555h-4.493L218,5.886a.332.332,0,1,0-.47-.47l-.886.882a.335.335,0,0,0-.069.363.323.323,0,0,0,.306.2h5.293A1.225,1.225,0,0,0,223.4,5.641V1.225A1.225,1.225,0,0,0,222.177,0Z",
    transform: "translate(-210.332)",
    fill: "#4776da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4075",
    "data-name": "Path 4075",
    d: "M310.588,108.613a.331.331,0,0,0,.331-.331.335.335,0,0,0-.331-.335h-1.773a.333.333,0,1,0,0,.666Z",
    transform: "translate(-299.621 -104.847)",
    fill: "#4776da"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestModule);
export default __webpack_public_path__ + "static/media/RequestModule.313d553ba605a0a7a3cf1dfcfa0eac18.svg";
export { ForwardRef as ReactComponent };